import apiClient from './AuthService';

export interface ImageCommentItem {
  image_comment_item_id: string;
  project_section_content_id: string;
  user_id?: string;
  image_url: string;
  comment: string;
  position: number;
  created_at?: string;
  updated_at?: string;
}

export interface ImageCommentItemsResponse {
  data: ImageCommentItem[];
  max_images: number;
}

export const getImageCommentItems = async (
  projectSectionContentId: string
): Promise<ImageCommentItemsResponse> => {
  try {
    const response = await apiClient.get<ImageCommentItemsResponse>(
      `/quiz/image-comment-items/${projectSectionContentId}`
    );
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return { data: [], max_images: 10 };
    }
    console.error('Error fetching image comment items:', error);
    throw error;
  }
};

export const saveImageCommentItem = async (params: {
  project_section_content_id: string;
  image_url: string;
  comment: string;
  position: number;
  image_comment_item_id?: string;
}): Promise<{ image_comment_item_id: string; message: string }> => {
  try {
    const response = await apiClient.post('/quiz/image-comment-items', params);
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};

export const deleteImageCommentItem = async (
  imageCommentItemId: string
): Promise<void> => {
  try {
    await apiClient.delete(`/quiz/image-comment-items/${imageCommentItemId}`);
  } catch (error: any) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};
